import React from 'react';
import { NavLink } from 'react-router-dom';
import './style.css'

const Card = ({ id, to, src, title, preview, date }) => {
  return (
    <NavLink
      style={{ textDecoration: 'none' }}
      id={id}
      to={to}
    >
      <div className='card-container'>
        <div className='card-img'>
          <img src={src} alt='cardImg' />
        </div>
        <div className='card-info'>
          <span className='title'>{title}</span>
          <div className='preview'>{preview}</div>
          <div className='card-date'>
            <div></div>
            <span>{date}</span>
          </div>
        </div>

      </div>
    </NavLink>
  )
}
export default Card;